import { BehaviorSubject } from 'rxjs';
import { ControlPanelButton } from '../abstract/control-panel-button';
import { Filmstrip } from '../abstract/filmstrip.class';
import { FilmstripType } from '../abstract/filmstrip.type';
import { Module } from '../abstract/module.class';
import { ModuleType } from '../abstract/module.type';
import { Background } from '../object';
import { Image } from '../object/image/image.class';
import { MultipleLineText } from '../object/multiple-line-text/multiple-line-text.class';
import { Text } from '../object/text/text.class';
import { WinningList } from '../object/winning-list/winning-list.class';
import { $ } from '../signal';

export class BrandLotteryFilmstrip extends Filmstrip {
  public override name = '品牌抽獎';

  public override type = FilmstripType.BRAND_LOTTERY;

  public override withMobileInteractive = true;

  public override projection = {
    background: new Background({
      type: 'IMAGE',
      src: 'assets/count-mario-bg.jpg',
    }),
  };

  public override mobileToolbar = {
    options: ['抽獎中', '中獎', '未中獎'],
    selectedOptionIndex: 0,
  };

  public override mobile = {
    background: new Background({ type: 'COLOR', hex: '#D0D9E4' }),
    title: new Text({ content: '恭喜中獎', align: 'center' }),
    spinText: new Text({ content: '抽獎中', align: 'center' }),
    card: {
      title: new Text({ content: '恭喜中獎', bolder: true, align: 'center' }),
      image: new Image({
        title: '獎品圖片',
        image:
          'https://gosubarpublic.blob.core.windows.net/static/2023/12/05/3111/upload/164657_68df956c-8f18-4420-8233-4f9415b249e8.jpg',
        width: 300,
        height: 200,
        fileFormats: ['jpeg', 'png'],
      }),
      useDefaultImage: $.signal(true),
      content: new MultipleLineText({
        content: '請前往櫃檯服務處，兌換禮物！',
      }),
    },
    noAwardText: new Text({ content: '未中獎', align: 'center', bolder: true }),
  };

  public override data = {};

  /** 控制面板下面的按鈕 */
  public override buttons: ControlPanelButton[] = [
    {
      label: '抽獎',
      icon: 'support',
      once: true,
      required$: new BehaviorSubject(false),
      method: 'spin',
      position: 'right',
      iconPosition: 'left',
      isExecuted$: new BehaviorSubject(false),
      disabled$: new BehaviorSubject(false),
    },
    {
      label: '加碼抽獎',
      icon: 'add',
      once: false,
      required$: new BehaviorSubject(false),
      method: 'extraSpin',
      position: 'right',
      iconPosition: 'left',
      isExecuted$: new BehaviorSubject(false),
      disabled$: new BehaviorSubject(false),
      params: [
        {
          title: '請輸入獎品名稱',
          label: '獎品名稱',
          type: 'string',
        },
        {
          title: '請輸入中獎人數',
          label: '中獎人數',
          type: 'number',
        },
      ],
    },
  ];

  public override _processError = $.computed(() => ({
    'projection.background': this.projection.background.error(),
    'mobile.background': this.mobile.background.error(),
  }));
}

export class BrandLotteryModule extends Module {
  public static override moduleName = '品牌抽獎';

  public override name = '品牌抽獎';

  public override type = ModuleType.BRAND_LOTTERY;

  public override readonly filmstrips = [new BrandLotteryFilmstrip()];

  public override showInCreateDialogOther = false;

  public override data = {
    winningList: new WinningList({ count: 10 }),
    // 特定使用者
    participantListApi: $.signal(''),
    // 用來控制參與者是全部還是沒有中過獎的
    participantRule: $.signal<'ALL' | 'NOT_WINNER'>('ALL'),
  };

  public override dataError = $.signal(null);

  public constructor(module: Partial<BrandLotteryModule> = {}) {
    super();
    this.fromJSON(module);
  }
}
